import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Tooltip } from "@components/Tooltip/Tooltip";
import {
  type ITaxCollectorType,
  type TaxCollectorTypeId,
} from "@services/payments/types";
import { formatImageSrc } from "@utils/common";
import { TaxCollectorTypeCheckbox } from "./TaxCollectorTypeCheckbox";

interface ITaxCollectorTypeProps {
  taxCollectorType: ITaxCollectorType;
  onSelect?: (taxCollectorType: ITaxCollectorType) => void;
  selectedId?: TaxCollectorTypeId;
  className?: string;
}

export const TaxCollectorType: React.FC<ITaxCollectorTypeProps> = (props) => {
  const { taxCollectorType, onSelect, selectedId, className } = props;
  const { t } = useTranslation();

  const hasTaxCollectorTypeARequirement =
    taxCollectorType.notMetRequirements.length > 0;
  const taxCollectorRequirement = taxCollectorType.notMetRequirements[0];

  return (
    <div
      onClick={() => onSelect?.(taxCollectorType)}
      className={twMerge(
        "relative flex min-w-52 cursor-pointer items-center gap-3 rounded-lg p-3 outline outline-1 outline-grey-light transition-all",
        selectedId === taxCollectorType.taxCollectorTypeId &&
          "outline-2 outline-green-dark",
        className,
      )}
    >
      <div className="flex h-12 w-12 min-w-12 max-w-12 items-center justify-center rounded-lg">
        {taxCollectorType.logo && (
          <img
            className="m-auto block max-h-full max-w-full object-contain"
            src={formatImageSrc(taxCollectorType.logo)}
            alt={taxCollectorType.name}
          />
        )}
      </div>
      <div className="flex flex-col">
        <h6>{taxCollectorType.name}</h6>{" "}
        {hasTaxCollectorTypeARequirement && (
          <span className="text-xs font-normal text-grey-dark">
            ({t(`taxCollectorRequirement.${taxCollectorRequirement}`)})
          </span>
        )}
      </div>
      {taxCollectorType.isChecked && (
        <Tooltip content={t("paymentSelectModal.checkedTooltip")}>
          {(props) => (
            <TaxCollectorTypeCheckbox
              className="absolute right-2 top-2 rounded-full border-none checked:bg-green-dark hover:checked:bg-green-dark focus:ring-0 focus:checked:bg-green-dark"
              checked={taxCollectorType.isChecked}
              readOnly
              {...props}
            />
          )}
        </Tooltip>
      )}
    </div>
  );
};
